import Flex from 'components/common/Flex';
import { useOAuth2 } from 'hooks/useOAuth2';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * Componente Authorized
 * Processa o callback OAuth2 após o redirecionamento do servidor de autorização
 *
 * Nota: A proteção contra execuções duplicadas (React 18 Strict Mode) é feita
 * diretamente no hook useOAuth2 usando um sistema de locks baseado em Promises.
 */
const Authorized = () => {
  const { handleAuthorizationCallback, isLoading, error } = useOAuth2();

  useEffect(() => {
    // O hook useOAuth2 possui proteção interna contra chamadas duplicadas
    // usando processingPromises Map como lock atômico
    const searchParams = new URLSearchParams(window.location.search);
    handleAuthorizationCallback(searchParams);
  }, [handleAuthorizationCallback]);

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <h1>Carregando...</h1>
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex alignItems="center" justifyContent="center" className="vh-100">
        <div className="text-center">
          <h1 className="text-danger mb-3">Erro na autenticação</h1>
          <p className="text-muted mb-4">{error}</p>

          <div className="d-grid gap-2 col-6 mx-auto">
            <Link to="/login" className="btn btn-primary">
              Tentar Login Novamente
            </Link>
            <button
              className="btn btn-outline-secondary"
              onClick={() => window.location.assign('/login')}
            >
              Recarregar Aplicação
            </button>
          </div>
        </div>
      </Flex>
    );
  }

  return null;
};

export default Authorized;
